import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const APHORISMS = [
  { text: "Simplicity is prerequisite for reliability.", author: "Edsger W. Dijkstra" },
  { text: "The treasury is the root of institutional and state stability.", author: "Kautilya's Arthashastra" },
  { text: "State transitions must be deterministic and invariant-preserving.", author: "Systems Axiom" },
  { text: "Zero-copy memory layouts beat pointer indirection at scale.", author: "POSIX Kernel Principle" },
  { text: "Universal computability is invariant across computational models.", author: "Alan Turing" },
  { text: "Programs must be written for people to read, and only incidentally for machines to execute.", author: "SICP (Abelson & Sussman)" }
];

const PhilosophyTicker = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        py: 1.4,
        px: { xs: 1.5, sm: 2.5 },
        borderRadius: '16px',
        backgroundColor: isDark ? 'rgba(0, 0, 0, 0.4)' : 'rgba(248, 245, 238, 0.8)',
        border: `1px solid ${isDark ? 'rgba(229, 169, 60, 0.25)' : 'rgba(184, 134, 11, 0.2)'}`,
        overflow: 'hidden',
        position: 'relative',
        mb: 6,
        display: 'flex',
        alignItems: 'center',
        boxShadow: isDark ? '0 4px 20px rgba(0,0,0,0.4)' : '0 2px 10px rgba(0,0,0,0.04)',
        maskImage: 'linear-gradient(to right, transparent 0%, black 4%, black 96%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 4%, black 96%, transparent 100%)',
        '&:hover .ticker-track': {
          animationPlayState: 'paused'
        }
      }}
    >
      {/* Infinite Scrolling Full-Width Quotes Track (No Fixed Badge) */}
      <Box
        className="ticker-track"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          whiteSpace: 'nowrap',
          animation: 'tickerScroll 38s linear infinite',
          '@keyframes tickerScroll': {
            '0%': { transform: 'translateX(0%)' },
            '100%': { transform: 'translateX(-50%)' }
          }
        }}
      >
        {[...APHORISMS, ...APHORISMS].map((item, idx) => (
          <Box key={idx} sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.2 }}>
            <Typography
              sx={{
                fontFamily: '"Newsreader", Georgia, serif',
                fontSize: { xs: '0.88rem', sm: '0.98rem' },
                fontStyle: 'italic',
                color: theme.palette.text.primary,
                letterSpacing: '0.01em'
              }}
            >
              "{item.text}"
            </Typography>
            <Typography
              sx={{
                fontFamily: '"JetBrains Mono", monospace',
                fontSize: '0.74rem',
                fontWeight: 700,
                color: isDark ? '#e5a93c' : '#b45309',
                opacity: 0.95
              }}
            >
              — {item.author}
            </Typography>
            <Typography sx={{ color: theme.palette.divider, fontSize: '0.8rem', pl: 2 }}>
              ◆
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PhilosophyTicker;
